import { render } from "./WatchTab.vue?vue&type=template&id=fc64e4f8&ts=true"
import script from "./WatchTab.vue?vue&type=script&lang=ts"
export * from "./WatchTab.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/render/project/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__